module.exports = __webpack_public_path__ + "img/BRI-Direct.12f68097.png";